import React, {FC} from 'react'
import classnames from 'classnames'
import StylesType from '@/types/StylesType'
import Button from '@/components/Button'
import {Row, Col} from 'antd'
import './style/Bottom.less'


export interface BottomTypes {
  totalPrice: string;
  deviceBuy: () => void
}

type BottomProps = StylesType & BottomTypes

const Bottom: FC<BottomProps> = props => {

  const {prefixCls = 'gc_', className, totalPrice, deviceBuy} = props

  return (
    <Row align='middle' type='flex' justify='space-between'
         className={classnames(className, prefixCls + 'machine_bottom')}>
      <Col>如果支付遇到问题，请联系QQ：2052972644</Col>
      <Col>
        <span>合计：</span>
        <span className={classnames('cF5222D')}>¥</span>
        <span className={classnames('cF5222D', 'f26')}>{totalPrice}</span>
        <Button onClick={deviceBuy} className={classnames('surePay')} size='xxl'>确定支付</Button>
      </Col>
    </Row>
  )
}


export default Bottom
